import forEach from 'lodash/forEach';
import pick from 'lodash/pick';
import { useEffect, useRef } from 'react';

const VALID_METADATA = ['title', 'description'];

const useMetadata = (metadata = {}, retainOnUnmount = true) => {
  const keys = Object.keys(metadata);

  if (!keys.every(key => VALID_METADATA.includes(key))) {
    console.error('Invalid metadata'); // eslint-disable-line no-console
    return;
  }

  const documentRef = useRef(pick(document, keys));

  useEffect(() => {
    forEach(metadata, (value, key) => {
      document[key] = value;
    });
  }, [metadata]);

  useEffect(() => {
    return () => {
      if (!retainOnUnmount) {
        forEach(keys, key => {
          document[key] = documentRef.current[key];
        });
      }
    };
  });
};

export default useMetadata;
